export const SlaLevelColumnId = {
  TYPE: 'type',
  SLA: 'sla',
  POTENTIAL_SIGNERS: 'potentialSignersFullNames',
  ACTUAL_SIGNERS: 'actualSignersFullNames',
  SLA_TYPE: 'slaType',
  ELIGIBLE_FOR_SIGN_OFF_DATE: 'eligibleForSignOffDate',
};

export const slaTableWidthMap = {
  [SlaLevelColumnId.TYPE]: '15%',
  [SlaLevelColumnId.SLA]: '12%',
  [SlaLevelColumnId.POTENTIAL_SIGNERS]: '22%',
  [SlaLevelColumnId.ACTUAL_SIGNERS]: '22%',
  [SlaLevelColumnId.SLA_TYPE]: '12%',
  [SlaLevelColumnId.ELIGIBLE_FOR_SIGN_OFF_DATE]: '17%',
};

export const SlaDurationType = {
  REGULAR_HOURS: 'RegularHours',
};

export const SlaDurationUnitLabel = {
  HOURS: 'Hours',
  DAYS: 'Days',
};
